import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible";
import { asChildSlot, resolveAsChild } from "~/lib/as-child";

function Collapsible({
  asChild,
  children,
  render,
  ...props
}: CollapsiblePrimitive.Root.Props & { asChild?: boolean }) {
  const resolved = asChildSlot({ asChild, children, render });
  return (
    <CollapsiblePrimitive.Root
      data-slot="collapsible"
      {...props}
      {...resolved}
    />
  );
}

function CollapsibleTrigger({
  asChild,
  children,
  render,
  nativeButton,
  ...props
}: CollapsiblePrimitive.Trigger.Props & { asChild?: boolean }) {
  const resolved = resolveAsChild({
    asChild,
    children,
    render,
    nativeButton,
  });
  return (
    <CollapsiblePrimitive.Trigger
      data-slot="collapsible-trigger"
      {...props}
      {...resolved}
    />
  );
}

function CollapsibleContent({ ...props }: CollapsiblePrimitive.Panel.Props) {
  return (
    <CollapsiblePrimitive.Panel data-slot="collapsible-content" {...props} />
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
